export enum CategoryType {
    ALL, ACCOUNT, PAYMENT, COUPON, ETC,
}

export const CategoryList = [
    {
        type: CategoryType.ALL,
        name: "전체"
    },
    {
        type: CategoryType.ACCOUNT,
        name: "계정"
    },
    {
        type: CategoryType.PAYMENT,
        name: "결제"
    },
    {
        type: CategoryType.COUPON,
        name: "쿠폰"
    },
    {
        type: CategoryType.ETC,
        name: "기타"
    }
];

export class CategoryInfo {
    static categoryTypes: string[] = [
        "전체", "계정", "결제", "쿠폰", "기타"
    ]

    static ordinalToName = (ordinal: number): string => {
        switch (ordinal) {
            case 0:
                return "전체";
            case 1:
                return "계정";
            case 2:
                return "결제";
            case 3:
                return "쿠폰";
            case 4:
                return "기타";
        }
        return "전체";
    }
}